import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
import { expertises } from "../data/content";
export function Expertises() {
  const [active, setActive] = useState(0);
  const current = expertises[active];
  return <section id="expertises" className="bg-sand py-24 lg:py-32" data-id="element-21" data-mp="1dj4kcwipjdvs">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-22" data-mp="1dkpckfhjukqh">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-23" data-mp="2a7alh9gf7o5b">
          <div className="max-w-2xl" data-id="element-24" data-mp="25ak66ocfwwky">
            <p className="text-[15px] font-medium text-muted" data-id="element-25" data-mp="25blrdln66zge">Expertises</p>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-26" data-mp="20h96r89yji32">
              Un accompagnement complet, de la veille à l'action.
            </h2>
          </div>
          <p className="max-w-md text-lg leading-relaxed text-muted" data-id="element-27" data-mp="2t17qya7gfgox">
            Chaque mission est construite sur mesure, selon votre calendrier réglementaire et vos priorités.
          </p>
        </div>

        <div className="mt-16 grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-28" data-mp="222kttbxz3deq">
          <div role="tablist" aria-label="Expertises" aria-orientation="vertical" className="lg:col-span-5" data-id="element-29" data-mp="26y9r18misi7v">
            {expertises.map((e, i) => {
            const selected = i === active;
            return <button key={e.title} role="tab" id={`exp-tab-${i}`} aria-selected={selected} aria-controls="exp-panel" onClick={() => setActive(i)} className={`group flex w-full items-center justify-between gap-4 border-b border-line py-6 text-left transition-colors duration-150 first:border-t ${selected ? "text-ink" : "text-muted hover:text-ink"}`} data-id="element-30" data-mp="1x7ostmardfph" data-mpi={i}>
                  <span className="font-display text-xl font-semibold sm:text-2xl" data-id="element-31" data-mp="38pgf5ob21k7o">{e.title}</span>
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${selected ? "bg-ink text-white" : "bg-white text-ink"}`} data-id="element-32" data-mp="378ap7e9ri3a8">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-33" data-mp="2xbeovvu0ongr" />
                  </span>
                </button>;
          })}
          </div>

          <div id="exp-panel" role="tabpanel" aria-labelledby={`exp-tab-${active}`} className="rounded-2xl bg-ink p-8 text-white sm:p-12 lg:col-span-7" data-id="element-34" data-mp="3px7ndt8a5fxq">
            <AnimatePresence mode="wait" data-id="element-35" data-mp="3g6wfjvlh6mlk">
              <motion.div key={active} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex h-full flex-col" data-id="element-36" data-mp="3c6ucpj407n4p">
                <h3 className="font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-37" data-mp="1qgfmg2duy3lm">{current.title}</h3>
                <p className="mt-5 text-lg leading-relaxed text-white/75" data-id="element-38" data-mp="1vfa3ays9li33">{current.summary}</p>
                <ul className="mt-10 space-y-5 border-t border-white/15 pt-8" data-id="element-39" data-mp="1zfas9dczpboe">
                  {current.details.map(d => <li key={d} className="flex gap-4 text-[17px] leading-relaxed text-white/90" data-id="element-40" data-mp="24d2k67dmwxsl">
                      <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-white/60" data-id="element-41" data-mp="29c5nnndyuvyg" />
                      {d}
                    </li>)}
                </ul>
                <a href="#contact" className="mt-12 inline-flex w-fit items-center gap-2 rounded-md bg-white px-6 py-3.5 text-[15px] font-medium text-ink transition-colors duration-150 hover:bg-sand" data-id="element-42" data-mp="2j5culcocuk0n">
                  Parler de votre projet
                  <ArrowRightIcon className="h-4 w-4" data-id="element-43" data-mp="2x4m9m90tr831" />
                </a>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}